import React from "react";
import { teamdata } from "../services/Teams";

const Playersind = () => {
    const indplayer = teamdata.filter((val)=> val.name==="India");
    const {players}=indplayer[0];
  return (
    <>
      <table class="table">
        <thead class="thead-dark">
          <tr>
          <th scope="col">Number</th>
            <th scope="col">Players</th>
            <th scope="col">Age</th>
            <th scope="col">Type</th>
          </tr>
        </thead>
        <tbody>
          {players.map((val) => (
            <tr>
              <th scope="row">{players.indexOf(val)+1}</th>
              <td>{val.name}</td>
              <td>{val.age}</td>
              <td>{val.type}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
};

export default Playersind;
